import React, {
  useContext,
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from 'react'
import {
  strCol,
  intCol,
  dateTimeCol,
  numCol,
} from '@integec/grid-tools/lib/cols'
import {
  modifierCol,
  modifiedDateCol,
  utilityReqHeader,
  unitHeader,
} from 'core/HeaderColTypeProps'
import { getApiTargetInfo, UnitSelection, ExportComponent } from 'core'
import { connect } from 'react-redux'
import R from 'ramda'
import {
  // getCard97,
  // deleteCard97,
  getSystemConfigurationInfo,
  // getUnitInfo,
  // getAmpCodeMgmtInfo,
  // getFailCodeMgmtInfo,
  getCard97Idx,
  getCauseCodeAll,
  getContribCondtition,
  // getCard97ExtensionSpec,
} from 'api/pgads'
import { getRetrieveServiceByClient } from './getServiceUtil'
import {
  getUtilityNameMap,
  getUnitNameMap,
  getUtilityUnitsMap,
  getCauseCodeMap,
  getUnits,
  getFailCode,
  getAmlificationCode,
  getPermitActions,
  getEnvConfig,
  getEventTypes,
  getCauseCodeOmcMap,
} from 'core/selectors'
import { Button, Input, Empty, message, Select } from 'antd'
import QuickFillDialog from './component/card97/QuickFill'
import QuickFillDialogBKF from './component/card97/QuickFillBkf'
import Card97EditPrompt from './component/card97/Card97EditAntd'
import CardsErrorDialog from './CardErrorDialogAntd'
import {
  UnitSelectionContext,
  SpinContext,
  ErrorContext,
  DatePickerContext,
} from 'context'
import { CriteriaRow, Title, Content, FullHeightSizer } from 'core/screen-util'
import Grid, {
  virtualizedGridRenderer,
  defaultVirtualizedCellRender,
  VirtualizedCell,
  extractAndFormatData,
} from '@integec/grid-tools'
import {
  rowHeaderRender,
  hasAccesPermits,
  exportDataComponent,
  getUnitCodeCauseCodeMapList,
} from 'core/utils'
import CauseCodePrompt from './MultiCauseCode'
import moment from 'moment'
import * as ScreenPermissions from 'core/EventActions'
import {
  BROOKFIELD_CLIENT,
  CALPLINE_CLIENT,
  CLECO,
  COOP_CLIENT,
  CPS_CLIENT,
  INTEG_CLIENT,
  NYISO_CLIENT,
  PJM_CLIENT,
  TVA_CLIENT,
  WEE_CLIENT,
} from 'client'
import { conCodeMap, updateCurrentCardDataAfterSave } from './utils'
// import DomNucExtension from './component/card97/DukeNucExtension'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import FilterContext, {
  effectvieFilterCount,
  getGridPropsObj,
} from '../context/FilterContext'

const curYear = new Date().getFullYear()

// const eventTypes = [
//   'D1',
//   'D2',
//   'D3',
//   'D4',
//   'DE',
//   'DM',
//   'DP',
//   'IR',
//   'MB',
//   'ME',
//   'MO',
//   'NC',
//   'PD',
//   'PE',
//   'PO',
//   'RS',
//   'SE',
//   'SF',
//   'U1',
//   'U2',
//   'U3',
// ]

// below changes lso refelect in event dashboard

export const headers = [
  unitHeader,
  intCol({ ident: 'year', display: 'Year', isKey: true, width: 50 }),
  intCol({
    ident: 'eventNum',
    display: 'Event Number',
    isKey: true,
    width: 60,
  }),
  intCol({ ident: 'eventIdx', display: 'Event Index', isKey: true, width: 60 }),
  strCol({
    ident: 'eventType',
    display: 'Event Type',
    isKey: true,
    isFiltered: true,
    width: 60,
  }),
  utilityReqHeader,
  dateTimeCol({
    ident: 'eventStart',
    display: 'Event Start Date',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
    isDateWithTime: true,
  }),
  dateTimeCol({
    ident: 'eventEnd',
    display: 'Event End Date',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
    isDateWithTime: true,
  }),
  strCol({ ident: 'availCap', display: 'Available Capacity' }),
  intCol({ ident: 'causeCode', display: 'Cause Code', isFiltered: true }),
  strCol({
    ident: 'causeCodeDescription',
    display: 'Cause Code Description',
    isFiltered: true,
    alignment: 'left',
    ellipsis: true,
    width: 250,
    // dataGetter: ({ rowData }) => causeCodeMap[rowData.causeCode],
  }),
  strCol({ ident: 'conCode', display: 'Contribution Code', width: 200 }),
  strCol({
    ident: 'eventTypeExternal',
    display: 'Contributing Operating Condition',
    isFiltered: true,
    width: 350,
    alignment: 'left',
    ellipsis: true,
  }),
  strCol({ ident: 'ioCode', display: 'Dominant' }),
  dateTimeCol({
    ident: 'workStart',
    display: 'Work Start Date',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
    isDateWithTime: true,
  }),
  dateTimeCol({
    ident: 'workEnd',
    display: 'Work End Date',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
    isDateWithTime: true,
  }),
  intCol({ ident: 'manHour', display: 'Man Hours' }),
  strCol({ ident: 'failCode', display: 'Fail Code', isFiltered: true }),
  strCol({ ident: 'ampCode', display: 'Amplification Code', isFiltered: true }),
  strCol({
    ident: 'description',
    display: 'Description',
    width: 2000,
    alignment: 'left',
    ellipsis: true,
  }),

  modifierCol,
  modifiedDateCol,
  // strCol({ ident: 'lock', display: 'Lock' }),
].map(e => ({ ...e, isFiltered: true }))

export const timeZoneList = R.compose(
  R.fromPairs,
  R.map(a => [`${a.utility}${a.unit}`, a.timeZone])
)
export const unitCodeList = R.compose(
  R.fromPairs,
  R.map(a => [`${a.utility}${a.unit}`, a.id1])
)
export const unitShortNameList = R.compose(
  R.fromPairs,
  R.map(a => [`${a.utility}${a.unit}`, a.shortName])
)
// const ampCodeList = R.compose(
//   R.fromPairs,
//   R.map(a => [a.ampCode, `[${a.ampCode}]${a.description}`])
// )
// const failCodeList = R.compose(
//   R.fromPairs,
//   R.map(a => [a.code, `[${a.code}]${a.description}`])
// )

const title = 'Card97 - Event Data'

const Card97 = ({
  utilityNameMap,
  unitNameMap,
  // utilityUnitMap,
  causeCodeMap,
  apiTargetInfo,
  actionPermits,
  envConfig,
  units,
  causeCodeOmcMap,
  ...props
}) => {
  // eslint-disable-next-line no-unused-vars
  const [isRetrieve, setISRetrieve] = useState(false)
  const CLIENT = envConfig.clientId || 'INTEG'
  const { spinning, setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const [data, setData] = useState(null)
  const [filterData, setFilterData] = useState([])
  const [causeCodeDialog, setCauseCodeDialog] = useState(false)
  const [causeCode, setCauseCode] = useState({})
  // const [loading, setLoading] = useState(false)
  const [errorPrompt, setErrorPropmt] = useState(false)
  const [errorSaveData, setErrorSaveData] = useState([])
  //  const [err, setError] = useState(null)
  const [selectedRows, setSelectedRows] = useState([])
  // const [selectedAll, setSelectedAll] = useState({})
  const [promptEdit, setPromptEdit] = useState(false)
  const [card97Dominant, setCard97Dominant] = useState(false)
  const [selEventTypes, setSelEventTypes] = useState(['ALL'])
  // const [unitsList, setUnitList] = useState([])
  const [timeZoneMap, setTimeZoneMap] = useState({})
  const [unitCodeMap, setUnitCodeMap] = useState({})
  const [unitShortNameMap, setUnitShortNameMap] = useState({})
  const [criteriaStartYear, setCriteriaStartYear] = useState(curYear - 18)
  const [criteriaEndYear, setCriteriaEndYear] = useState(curYear + 4)
  // const [ampCodeMap, setAmpCodeMap] = useState({})
  // const [failCodeMap, setFailCodeMap] = useState({})
  const { selectedUnits, setVisibleUnitSelection } = useContext(
    UnitSelectionContext
  )
  const { setSelectedDateRagePicker } = useContext(DatePickerContext)
  const {
    setGridProps,
    setDrawerVisible,
    setFilterCondition,
    filterCondition,
  } = useContext(FilterContext)

  const yearOption = useMemo(() => {
    return R.range(criteriaStartYear, criteriaEndYear + 1)
      .sort((a, b) => b - a)
      .map(i => (
        <Select.Option value={i} key={i}>
          {i}
        </Select.Option>
      ))
  }, [criteriaStartYear, criteriaEndYear])
  useEffect(
    _ => {
      const mom = moment(curYear + '1231')
      setSelectedDateRagePicker([mom.clone().startOf('year'), mom])
    },
    [setSelectedDateRagePicker]
  )

  const eventTypes = useMemo(_ => props.eventTypesData.map(e => e.eventType), [
    props.eventTypesData,
  ])
  const eventTypeOptions = R.compose(
    R.fromPairs,
    R.map(e => [e, e])
  )([...eventTypes, 'CO', 'PU'])
  const [causeCodeList, setCauseCodeList] = useState([])
  //  const [contribCondList, setContribCondList] = useState([])
  const [contribCondMap, setContribCondMap] = useState([])
  useEffect(
    _ => {
      getCauseCodeAll(apiTargetInfo).fork(setError, setCauseCodeList)
      getContribCondtition(apiTargetInfo).fork(
        _ => _,
        data => {
          setContribCondMap(
            R.compose(
              R.fromPairs,
              R.map(({ code, description }) => [
                code,
                code + ' - ' + description,
              ])
            )(data)
          )
        }
      )
    },
    [apiTargetInfo, setError]
  )

  const [showQuickFillDialog, setShowQuickfillDialog] = useState(false)

  const [year, setYear] = useState(curYear)

  const [mode, setMode] = useState(null)

  const setErr = useCallback(
    err => {
      setError(err)
      setSpinning(false)
      setData(null)
      setFilterData([])
    },
    [setError, setSpinning]
  )

  const selectionChange = selected => {
    setSelectedRows(selected.selectedRows)
    // setSelectedAll(selected)
  }
  const setEditPromptvisible = visible => setPromptEdit(visible)

  useEffect(
    _ => {
      getSystemConfigurationInfo(apiTargetInfo).fork(setErr, d => {
        const dominantData = d.filter(
          s => s.key === 'DOMINANT_DERATE' && s.value === 'YES'
        )

        const criteriaStartYearItem = d.find(
          s => s.key === 'CRITERIA_START_YEAR'
        )
        const criteriaEndYearItem = d.find(s => s.key === 'CRITERIA_END_YEAR')
        // setState({ card97Dominant: dominantData.length > 0 ? true : false, loading: false })
        setCriteriaStartYear(
          criteriaStartYearItem
            ? parseInt(criteriaStartYearItem.value)
            : curYear - 18
        )
        setCriteriaEndYear(
          criteriaEndYearItem
            ? parseInt(criteriaEndYearItem.value)
            : curYear + 4
        )
        setCard97Dominant(dominantData.length > 0)
      })
      // getCard97ExtensionSpec(apiTargetInfo).fork(setErr, d =>
      //   setExtensionSpec(d.length > 0 ? d[0] : {})
      // )
      setTimeZoneMap(timeZoneList(units))
      setUnitCodeMap(unitCodeList(units))
      setUnitShortNameMap(unitShortNameList(units))
    },
    [apiTargetInfo, setErr, units]
  )

  const cardFreezeAccess = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.CARD_FREEZE],
        matchAny: true,
      }),
    [actionPermits]
  )

  const freezeHeaders = [
    unitHeader,
    intCol({ ident: 'year', display: 'Year', isKey: true, width: 50 }),
    intCol({
      ident: 'eventNum',
      display: 'Event Number',
      isKey: true,
      width: 60,
    }),
    intCol({
      ident: 'eventIdx',
      display: 'Event Index',
      isKey: true,
      width: 60,
    }),
    strCol({
      ident: 'eventType',
      display: 'Event Type',
      isKey: true,
      isFiltered: true,
      width: 60,
    }),
    strCol({
      ident: 'utility',
      display: 'Utility',
      width: 450,
      // isKey: true,
      sortOrder: 'asc',
      ellipsis: true,
    }),
    dateTimeCol({
      ident: 'eventStart',
      display: 'Event Start Date',
      width: 150,
      displayFormat: 'MM/DD/YYYY HH:mm',
      isDateWithTime: true,
    }),
    dateTimeCol({
      ident: 'eventEnd',
      display: 'Event End Date',
      width: 150,
      displayFormat: 'MM/DD/YYYY HH:mm',
      isDateWithTime: true,
    }),
    strCol({ ident: 'availCap', display: 'Available Capacity' }),
    strCol({ ident: 'conCode', display: 'Contribution Code', width: 200 }),
    intCol({ ident: 'causeCode', display: 'Cause Code', isFiltered: true }),
    strCol({
      ident: 'causeCodeDescription',
      display: 'Cause Code Description',
      isFiltered: true,
      alignment: 'left',
      ellipsis: true,
      width: 250,
      dataGetter: ({ rowData }) => causeCodeMap[rowData.causeCode],
    }),
    strCol({
      ident: 'eventTypeExternal',
      display: 'Contributing Operating Condition',
      isFiltered: true,
      width: 350,
      alignment: 'left',
      ellipsis: true,
    }),
    strCol({ ident: 'ioCode', display: 'Dominant' }),
    dateTimeCol({
      ident: 'workStart',
      display: 'Work Start Date',
      width: 150,
      displayFormat: 'MM/DD/YYYY HH:mm',
      isDateWithTime: true,
    }),
    dateTimeCol({
      ident: 'workEnd',
      display: 'Work End Date',
      width: 150,
      displayFormat: 'MM/DD/YYYY HH:mm',
      isDateWithTime: true,
    }),
    intCol({ ident: 'manHour', display: 'Man Hours' }),
    strCol({ ident: 'failCode', display: 'Fail Code', isFiltered: true }),
    strCol({
      ident: 'ampCode',
      display: 'Amplification Code',
      isFiltered: true,
    }),
    strCol({
      ident: 'description',
      display: 'Description',
      width: 2000,
      alignment: 'left',
      ellipsis: true,
    }),

    modifierCol,
    modifiedDateCol,
    // strCol({ ident: 'lock', display: 'Lock' }),
  ].map(e => ({ ...e, isFiltered: true }))

  const onRetrieveData = ({ selUnits = selectedUnits }) => {
    if (selUnits.length <= 0) {
      setVisibleUnitSelection(true)
      message.error('Please,Select Unit')
      return
    }
    if (selEventTypes.length <= 0) {
      message.error('Please,Select Event Types')
      return
    }
    setSpinning(true)
    getRetrieveServiceByClient(CLIENT)(apiTargetInfo)(
      year || curYear,
      selUnits[0].utility,
      selUnits.map(u => u.unitId),
      selEventTypes.includes('ALL')
        ? [...eventTypes, 'CO', 'PU']
        : selEventTypes
    ).fork(setErr, data => {
      setSpinning(false)
      setISRetrieve(true)
      setData(data)
      setFilterData(data)
      setFilterCondition([{}])

      if (GridRef.current) GridRef.current.setSelectedRect({})
    })
  }

  const onDelete = () => {
    setMode('D')
    setEditPromptvisible(true)
  }

  const onInsert = _ => {
    // todo : chekc for Lock s
    setMode('N')
    setEditPromptvisible(true)
  }

  const onView = _ => {
    setMode('V')
    setEditPromptvisible(true)
  }

  const quickfillMultiple = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.CARD97_DIALOG_QUICKFILL_MULTIPLE],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  const CurrentQuickFillDialog = useMemo(
    _ => (quickfillMultiple ? QuickFillDialogBKF : QuickFillDialog),
    [quickfillMultiple]
  )

  const onQuickUpdate = _ => {
    if (!quickfillMultiple)
      if (selectedRows[0].lock === 'L' || selectedRows[0].lock === 'C') {
        message.error(
          `${selectedRows[0].unit.substring(selectedRows[0].utility.length)}-${
            unitNameMap[selectedRows[0].unit]
          } is locked for the selected date.`
        )
        return
      }
    setShowQuickfillDialog(true)
  }

  const onUpdate = _ => {
    if (selectedRows[0].lock === 'L') {
      message.error(
        `${selectedRows[0].unit.substring(selectedRows[0].utility.length)}-${
          unitNameMap[selectedRows[0].unit]
        } is locked for the selected date.`
      )
      return
    }

    setMode('E')
    setEditPromptvisible(true)
  }

  const [fuzzyFilter, setFuzzyFilter] = useState('')
  const card97Admin = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.CARD97_ADMIN],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const onCauseCodeDialogClose = (selectedKeys, selectedValues) => {
    setCauseCodeDialog(false)
    setCauseCode({ selectedKeys, selectedValues })
  }
  const onCauseCodeTreeCancel = _ => setCauseCodeDialog(false)

  // if required change bellow then also change in eventdashboard
  const clientHeaders = useMemo(
    _ => {
      const header = cardFreezeAccess ? freezeHeaders : headers

      if (CLIENT === PJM_CLIENT) {
        const WEline = strCol({
          ident: 'line',
          display: 'Pending',
        })

        return R.insert(header.length, WEline, header)
      } else if (
        CLIENT === WEE_CLIENT ||
        CLIENT === CPS_CLIENT ||
        CLIENT === CALPLINE_CLIENT ||
        CLIENT === CLECO
      ) {
        const WEline = numCol({
          ident: 'line',
          display: 'Duration (HRS)',
        })

        return R.insert(8, WEline, header)
      } else if (CLIENT === BROOKFIELD_CLIENT) {
        const BKFline = numCol({
          ident: 'line',
          display: 'Spill MWH',
        })

        return R.insert(9, BKFline, header)
      } else if (CLIENT === COOP_CLIENT) {
        const coopEventGroup = intCol({
          ident: 'coopeventGroup',
          display: 'Event Group',
          width: 70,
        })

        return R.insert(5, coopEventGroup, header)
      }
      return header
    },
    [CLIENT, cardFreezeAccess, freezeHeaders]
  )

  const filterHeaders = useMemo(
    _ =>
      card97Dominant
        ? clientHeaders
        : clientHeaders.filter(h => !(h.ident === 'ioCode')),
    [card97Dominant, clientHeaders]
  )

  const headerWithFormatter = useMemo(
    _ =>
      filterHeaders.map(header =>
        header.ident === 'utility'
          ? {
              ...header,

              dataFormatter: ({ value }) =>
                utilityNameMap[value]
                  ? value + ' - ' + utilityNameMap[value]
                  : value,
              sortIndexGetter: ({ rowData }) =>
                utilityNameMap[rowData.utility] || rowData.utility,
            }
          : header.ident === 'unit'
          ? {
              ...header,
              // choices: [],
              dataFormatter: ({ value }) =>
                unitNameMap[value]
                  ? value.substr(3) + ' - ' + unitNameMap[value]
                  : value,
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.unit] || rowData.unit,
            }
          : header.ident === 'conCode'
          ? {
              ...header,
              ...toSelectionColProps(conCodeMap),
              width: 200,
              ellipsis: true,
              alignment: 'left',
            }
          : header.ident === 'eventTypeExternal'
          ? {
              ...header,
              ...toSelectionColProps(contribCondMap),
              dataGetter: ({ rowData }) => {
                // const rval = (rowData.extension || {}).eventTypeExternal || '0'
                const rval = (rowData.extension || {}).eventTypeExternal
                const val = contribCondMap[rval]
                return val
              },
            }
          : header.ident === 'causeCodeDescription'
          ? // header.ident === 'causeCode'
            {
              ...header,
              // ...toSelectionColProps(causeCodeMap),
              dataFormatter: ({ rowData }) => causeCodeMap[rowData.causeCode],
              dataGetter: ({ rowData }) => causeCodeMap[rowData.causeCode],
            }
          : header.ident === 'coopeventGroup'
          ? {
              ...header,

              dataGetter: ({ rowData }) => {
                // const rval = (rowData.extension || {}).eventTypeExternal || '0'
                const rval = (rowData.extension || {}).number1

                return rval
              },
            }
          : header.ident === 'eventType'
          ? {
              ...header,
              ...toSelectionColProps(eventTypeOptions),
            }
          : header
      ),
    [
      filterHeaders,
      contribCondMap,
      eventTypeOptions,
      utilityNameMap,
      unitNameMap,
      causeCodeMap,
    ]
  )

  const GridRef = useRef()

  const unitCodeCauseCodeMap = useMemo(
    _ => getUnitCodeCauseCodeMapList(causeCodeList),
    [causeCodeList]
  )

  // const onFilterByValue = _ => {
  //   const { selectedHeaders = [], selectedRows = [] } = selectedAll || {}
  //   if (selectedHeaders.length <= 0) {
  //     message.warn('Please , Select cell')
  //     return
  //   }
  //   const idents = selectedHeaders.map(d => d.ident)

  //   const mapValueFilter = R.compose(
  //     R.fromPairs,
  //     R.map(d => [d, selectedRows.map(v => v[d])])
  //   )(idents)

  //   const filterData = data.filter(d => {
  //     const isValid = idents.map(id => {
  //       const curValList = mapValueFilter[id]

  //       return curValList.includes(d[id])
  //     })

  //     return isValid.includes(true)
  //   })
  //   setSelectedAll({})
  //   setSelectedRows([])
  //   setFilterData(filterData)
  // }

  useEffect(() => {
    const gridProps = getGridPropsObj(headerWithFormatter, data, setFilterData)
    setGridProps(gridProps)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, setGridProps])

  const openFilterDialog = () => {
    setDrawerVisible(true)
  }

  return (
    <>
      {false && causeCodeDialog && (
        <CauseCodePrompt
          causeCodeList={causeCodeList}
          unitCodeCauseCodeMap={unitCodeCauseCodeMap}
          key="card97maincausecodeprompt"
          // style={{ ...inlineStyle }}
          // checkable={false}
          visibleDialog={causeCodeDialog}
          onDialogClose={onCauseCodeDialogClose}
          onCancelAction={onCauseCodeTreeCancel}
          defaultExpandedKeys={causeCode ? causeCode.selectedKeys : []}
          //       defaultExpandedKeys={
          //         /*(causeCodeKeyValues &&
          // causeCodeKeyValues.length > 0 &&
          // causeCodeKeyValues) ||*/
          //         (causeCode && [unitCodeMap[unit] + '-' + causeCode]) || []
          //       }
          // unitCode={unitCodeMap && unitCodeMap[selectedUnits[0]]}
          unitCodes={R.uniq(
            selectedUnits.map(u => u.unitId).map(u => unitCodeMap[u])
          )}
          multiple
          checkable
          selectable={false}
        />
      )}
      {showQuickFillDialog && (
        <CurrentQuickFillDialog
          causeCodeList={causeCodeList}
          CLIENT={CLIENT}
          timeZoneMap={timeZoneMap}
          unitCodeMap={unitCodeMap}
          visible={showQuickFillDialog}
          onOk={_ => {
            onRetrieveData({})
            setShowQuickfillDialog(false)
          }}
          onCancel={_ => setShowQuickfillDialog(false)}
          {...selectedRows[0]}
          data={selectedRows[0]}
          targetInfo={apiTargetInfo}
          ampCodeMap={props.ampCodeMap}
          failCodeMap={props.failCodeMap}
          unitShortNameMap={unitShortNameMap}
          spinning={spinning}
          setSpinning={setSpinning}
          setError={setErr}
          retrieveData={onRetrieveData}
          errorSaveData={errorSaveData}
          setErrorSaveData={setErrorSaveData}
          setErrorPropmt={setErrorPropmt}
          unitsList={units}
          dataList={selectedRows}
          utilityNameMap={utilityNameMap}
          unitNameMap={unitNameMap}
          setData={(curCard, actionType) => {
            // Apply the edit to both the displayed (filtered) list and the
            // full source data — each from its own previous value so the
            // filtered-out rows are preserved and the change survives a
            // re-filter.
            setFilterData(prev =>
              updateCurrentCardDataAfterSave(prev, curCard, actionType)
            )
            setData(prev =>
              updateCurrentCardDataAfterSave(prev, curCard, actionType)
            )
          }}
        />
      )}
      {promptEdit && (
        <Card97EditPrompt
          unitCodeCauseCodeMap={unitCodeCauseCodeMap}
          causeCodeList={causeCodeList}
          CLIENT={CLIENT}
          key="card97editprompt"
          retrieveData={onRetrieveData}
          mode={mode}
          setMode={setMode}
          targetInfo={apiTargetInfo}
          rowData={
            mode === 'E' || mode === 'D' || mode === 'V'
              ? selectedRows[0]
              : {
                  utility:
                    selectedUnits.length === 1
                      ? selectedUnits[0].utility
                      : null,
                  unit:
                    selectedUnits.length === 1
                      ? selectedUnits[0].utility + selectedUnits[0].unit
                      : null,
                  year,
                  eventNum: -1,
                  conCode: '1',
                }
          }
          utilityNameMap={utilityNameMap}
          unitNameMap={unitNameMap}
          criteriaYear={year}
          criteriaUtility={
            selectedUnits.length === 1 ? selectedUnits[0].utility : ''
          }
          criteriaUnit={
            selectedUnits.length === 1 ? selectedUnits[0].unitId : ''
          }
          timeZoneMap={timeZoneMap}
          card97Dominant={card97Dominant}
          unitsList={units}
          ampCodeMap={props.ampCodeMap}
          failCodeMap={props.failCodeMap}
          unitCodeMap={unitCodeMap}
          unitShortNameMap={unitShortNameMap}
          getCardIdx={getCard97Idx(apiTargetInfo)}
          idxData={[]}
          causeCodeMap={causeCodeMap}
          promptEdit={promptEdit}
          setEditPromptvisible={setEditPromptvisible}
          headers={headerWithFormatter}
          apiTargetInfo={apiTargetInfo}
          // extendedCard={ps => <DomNucExtension {...ps} />}
          setData={(curCard, actionType) => {
            // Apply the edit to both the displayed (filtered) list and the
            // full source data — each from its own previous value so the
            // filtered-out rows are preserved and the change survives a
            // re-filter.
            setFilterData(prev =>
              updateCurrentCardDataAfterSave(prev, curCard, actionType)
            )
            setData(prev =>
              updateCurrentCardDataAfterSave(prev, curCard, actionType)
            )
          }}
          allowRetrieve={false}
        />
      )}
      <div
        style={{
          backgroundColor: '#f0f2f5',
          marginLeft: '20px',
          marginRight: '20px',
        }}
      >
        <UnitSelection
          setData={() => {
            setData(null)
            setFilterData([])
          }}
          accesskey="u"
          retrieveData={onRetrieveData}
        />
        <CriteriaRow style={{}}>
          <Title
            style={{
              marginRight: '15px',
              marginBottom: '5px',
              marginLeft: '10px',
              minWidth: '200px',
            }}
          >
            {title}
          </Title>
          <div
            style={{
              display: 'grid',
              gridGap: '15px',
              width: '100%',
              gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr',
            }}
          >
            <div
              style={{
                display: 'grid',
                justifyContent: 'end',
                alignContent: 'center',
                gridTemplateColumns: '100px auto',
              }}
            >
              <div
                style={{
                  display: 'grid',
                  justifyContent: 'center',
                  alignContent: 'center',
                }}
              >
                Year :
              </div>
              <Select
                id="year"
                style={{ minWidth: '90px' }}
                value={year}
                onChange={year => {
                  setYear(year)
                  setData([])
                  setFilterData([])
                  setSelectedRows([])
                  const mom = moment(year + '1231')
                  setSelectedDateRagePicker([mom.clone().startOf('year'), mom])
                }}
              >
                {yearOption}
              </Select>
            </div>
            {/* <Button onClick={e => setCauseCodeDialog(true)}>Cause Code</Button> */}
            <div
              style={{
                display: 'grid',
                justifyContent: 'end',
                alignContent: 'center',
              }}
            >
              Event Type :
            </div>
            <Select
              onChange={vals => {
                setSelEventTypes(vals)
                setData([])
                setFilterData([])
              }}
              value={selEventTypes}
              placeholder="Select Event Types"
              mode="multiple"
              style={{ gridColumnEnd: 'span 4' }}
            >
              <Select.Option value="ALL">ALL</Select.Option>
              {eventTypes.map(k => (
                <Select.Option value={k} key={k}>
                  {k}
                </Select.Option>
              ))}
              {(CLIENT === BROOKFIELD_CLIENT ||
                CLIENT === TVA_CLIENT ||
                CLIENT === NYISO_CLIENT) && [
                <Select.Option value="CO" key="CO">
                  CO
                </Select.Option>,
                <Select.Option value="PU" key="PU">
                  PU
                </Select.Option>,
              ]}
            </Select>
            <Button
              style={{}}
              onClick={onRetrieveData}
              type="primary"
              icon="database"
            >
              Retrieve
            </Button>

            {/* <Filler /> */}
            {card97Admin && (
              <>
                <Button
                  icon="plus-circle"
                  style={{ backgroundColor: '#e6f7ff' }}
                  onClick={onInsert}
                  // disabled={!isRetrieve}
                >
                  Insert
                </Button>
                <Button
                  onClick={onUpdate}
                  type="primary"
                  disabled={selectedRows.length <= 0}
                  style={{}}
                  icon="edit"
                >
                  Update
                </Button>
                <Button
                  onClick={onQuickUpdate}
                  type="primary"
                  disabled={selectedRows.length === 0}
                  style={{}}
                  icon="edit"
                >
                  Quick Update
                </Button>
                <Button
                  onClick={_ => onDelete({ selectedUnits })}
                  style={{}}
                  type="danger"
                  disabled={selectedRows.length <= 0}
                  icon="delete"
                >
                  Delete
                </Button>
              </>
            )}
            {!card97Admin && (
              <>
                <div />
                <div />
                <div />
                <div />
              </>
            )}

            <Input.Search
              placeholder="Filter"
              value={fuzzyFilter}
              style={{
                gridColumnEnd: 'span 1',
              }}
              onChange={e => setFuzzyFilter(e.target.value)}
            />
            {/* <Button onClick={onFilterByValue}> Filter By Value</Button> */}
            <Button
              onClick={openFilterDialog}
              type="dashed"
              icon="filter"
              // disabled={!isRetrived}
            >
              Filter Data ({effectvieFilterCount(filterCondition)})
            </Button>
            <ExportComponent
              getData={_ =>
                exportDataComponent(GridRef, filterData, fuzzyFilter)
              }
              data={filterData}
              headers={headerWithFormatter}
              fileName={title}
              btnStyle={{}}
              disabled={!!(filterData && filterData.length <= 0)}
            />
          </div>
        </CriteriaRow>
        <FullHeightSizer heightOffset={300}>
          {({ height, width }) =>
            filterData && filterData.length > 0 ? (
              <Content style={{ height: height - 20, width }}>
                <Grid
                  ref={GridRef}
                  sortEnabled
                  data={filterData}
                  headers={headerWithFormatter}
                  altBy={u => u.unit}
                  altBgColor="#ebebeb"
                  // onEditInfoChange={info => editRow(info)}
                  // editInfo={editInfo}
                  render={virtualizedGridRenderer({
                    autoFixColByKey: cardFreezeAccess,
                    rowHeaderRender,
                    height: height - 60,
                    width: width - 50,
                    cellRender: card97TableCellRender({
                      onView,
                      causeCodeOmcMap,
                      CLIENT,
                    }),
                  })}
                  fuzzyFilter={fuzzyFilter}
                  isEditable={false}
                  onSelectionChange={rows => {
                    selectionChange(rows)
                  }}
                  selectionMode={quickfillMultiple ? 'multi' : 'single'}
                  // selectionType="cell"
                  initialSortOptions={[
                    utilityReqHeader,
                    unitHeader,
                    { ident: 'year', sortOrder: 'asc' },
                    { ident: 'eventStart', sortOrder: 'asc' },
                    { ident: 'eventEnd', sortOrder: 'asc' },
                    // { ident: 'year', sortOrder: 'asc' },
                    { ident: 'eventNum', sortOrder: 'asc' },
                    // { ident: 'eventIdx', sortOrder: 'asc' },
                  ]}
                />
              </Content>
            ) : (
              <Content style={{ height: '200px' }}>
                <Empty
                  imageStyle={{ paddingTop: '30px' }}
                  description={
                    selectedUnits && selectedUnits.length <= 0
                      ? 'Please select units'
                      : data && data.length <= 0
                      ? 'No Data from Retrieve'
                      : 'Please click on retrieve button to retrieve data'
                  }
                />
              </Content>
            )
          }
        </FullHeightSizer>
      </div>
      {errorPrompt && (
        <CardsErrorDialog
          keys="card97errordialog"
          errors={errorSaveData}
          closeErrorPrompt={_ => setErrorPropmt(false)}
          action={mode}
          visible={!!errorPrompt}
          retrieveData={onRetrieveData}
          setShowEditDialog={_ => setShowQuickfillDialog(false)}
          allowRetrieve={false}
        />
      )}
    </>
  )
}

// getAmpCodeMgmtInfo(apiTargetInfo).fork(setErr, d => setAmpCodeMap(ampCodeList(d)))
//  getFailCodeMgmtInfo(apiTargetInfo).fork(setErr, d => setFailCodeMap(failCodeList(d)))

export const card97TableCellRender = ({
  onView = _ => _,
  causeCodeOmcMap,
  CLIENT = INTEG_CLIENT,
}) => params => {
  const { gridToolProps, reactVirtualizedProps } = params

  const { getCellProps, headers, data } = gridToolProps

  const { columnIndex, rowIndex, style } = reactVirtualizedProps
  // const cellProps = getCellProps({
  //   rowIndex,
  //   columnIndex,
  //   header: headers[columnIndex],
  //   data,
  //   style,
  //   ...rest,
  // })

  const cellData = extractAndFormatData({
    rowData: data[rowIndex],
    header: headers[columnIndex],
  })

  if (headers[columnIndex].ident === 'causeCode') {
    const isOmc = causeCodeOmcMap[cellData]
    let omcCellProps = getCellProps({
      rowIndex,
      columnIndex,
      header: headers[columnIndex],
      data,
      style,
    })

    omcCellProps = {
      ...omcCellProps,
      style: {
        ...style,
        backgroundColor: isOmc
          ? 'rgb(255,128,64,0.5)'
          : cellData >= 9180 && cellData <= 9199
          ? 'rgb(194,57,237,0.5)'
          : undefined,
        color:
          omcCellProps.isSelected && isOmc
            ? 'black'
            : cellData >= 9180 && cellData <= 9199
            ? 'black'
            : undefined,
      },
    }

    return (
      <VirtualizedCell
        {...R.omit(['data'], omcCellProps)}
        onDoubleClick={_ => {
          // onUpdate()
          onView()
        }}
      >
        {cellData}
      </VirtualizedCell>
    )
  }

  if (CLIENT === PJM_CLIENT && headers[columnIndex].ident === 'line') {
    let lineCellProps = getCellProps({
      rowIndex,
      columnIndex,
      header: headers[columnIndex],
      data,
      style,
    })

    lineCellProps = {
      ...lineCellProps,
      style: {
        ...style,
        backgroundColor: cellData === 'Y' && 'rgb(194,57,237,0.5)',
      },
    }

    return (
      <VirtualizedCell
        {...R.omit(['data'], lineCellProps)}
        onDoubleClick={_ => {
          // onUpdate()
          onView()
        }}
      >
        {cellData}
      </VirtualizedCell>
    )
  }

  return defaultVirtualizedCellRender({
    ...params,
    onDoubleClick: _ => {
      // onUpdate()
      onView()
    },
  })
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  utilityUnitMap: getUtilityUnitsMap(state),
  causeCodeMap: getCauseCodeMap(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
  units: getUnits(state),
  ampCodeMap: getAmlificationCode(state),
  failCodeMap: getFailCode(state),
  eventTypesData: getEventTypes(state),
  causeCodeOmcMap: getCauseCodeOmcMap(state),
})
export default connect(mapStateToProps)(Card97)
